import React from 'react';

import { Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useStyles } from './PostSkeleton.styles';

export default function PostSkeleton() {
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <div className={classes.postWrapper}>
      <div className={classes.header}>
        <div className={classes.userSection}>
          <Skeleton variant="circular" width={40} height={40} />
          <div className={classes.userInfo}>
            <Skeleton variant="text" width="70%" height={20} />
            <Skeleton variant="text" width="45%" height={16} />
          </div>
        </div>
        <div className={classes.actions}>
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="circular" width={24} height={24} />
        </div>
      </div>

      <div className={classes.content}>
        <Skeleton variant="text" width="100%" height={20} />
        <Skeleton variant="text" width="92%" height={20} />
        <Skeleton variant="text" width="68%" height={20} />
      </div>

      <div className={classes.footer}>
        <Skeleton variant="circular" width={28} height={28} />
        <Skeleton variant="circular" width={28} height={28} />
        <Skeleton variant="circular" width={28} height={28} />
      </div>
    </div>
  );
}
